// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: #f5f6f7;
}

.page-header {
  padding: 10px 20px;
  background: #ffffff;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #9ca3af;
  margin-bottom: 8px;
}

.breadcrumb i {
  font-size: 16px;
}

.breadcrumb-separator {
  color: #d1d5db;
}

.page-header h1 {
  font-size: 22px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  text-align: left;
}

.page-body {
  background: #ffffff;
  margin: 8px 8px;
  border-radius: 8px;
  padding: 16px 20px;
  border: 1px solid #e5e7eb;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.loading {
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #666;
}

.error {
  background: #f8d7da;
  color: #721c24;
  padding: 15px;
  border-radius: 6px;
  margin-bottom: 20px;
  border: 1px solid #f5c6cb;
}

.firmware-versions-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.firmware-versions-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}

.selection-info {
  display: flex;
  align-items: center;
  color: #666;
  font-size: 15px;
  margin-right: auto;
}

.badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
}

.badge-success {
  background: #d4edda;
  color: #155724;
}

.badge-secondary {
  background: #e2e3e5;
  color: #383d41;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover {
  background: #0056b3;
}

.btn-sm {
  padding: 6px 12px;
  font-size: 13px;
  margin-right: 5px;
}

.btn-info {
  background: #17a2b8;
  color: white;
}

.btn-info:hover {
  background: #138496;
}

.btn-danger {
  background: #dc3545;
  color: white;
}

.btn-danger:hover {
  background: #c82333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LicenseManagement/FirmwareVersions/FirmwareVersions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".page-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n  background: #f5f6f7;\n}\n\n.page-header {\n  padding: 10px 20px;\n  background: #ffffff;\n  border-bottom: 1px solid #e5e7eb;\n  flex-shrink: 0;\n}\n\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #9ca3af;\n  margin-bottom: 8px;\n}\n\n.breadcrumb i {\n  font-size: 16px;\n}\n\n.breadcrumb-separator {\n  color: #d1d5db;\n}\n\n.page-header h1 {\n  font-size: 22px;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n  text-align: left;\n}\n\n.page-body {\n  background: #ffffff;\n  margin: 8px 8px;\n  border-radius: 8px;\n  padding: 16px 20px;\n  border: 1px solid #e5e7eb;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.loading {\n  text-align: center;\n  padding: 40px;\n  font-size: 18px;\n  color: #666;\n}\n\n.error {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 15px;\n  border-radius: 6px;\n  margin-bottom: 20px;\n  border: 1px solid #f5c6cb;\n}\n\n.firmware-versions-content {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.firmware-versions-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n  padding-bottom: 12px;\n  margin-bottom: 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.selection-info {\n  display: flex;\n  align-items: center;\n  color: #666;\n  font-size: 15px;\n  margin-right: auto;\n}\n\n.badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.badge-success {\n  background: #d4edda;\n  color: #155724;\n}\n\n.badge-secondary {\n  background: #e2e3e5;\n  color: #383d41;\n}\n\n.btn {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-primary {\n  background: #007bff;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #0056b3;\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 13px;\n  margin-right: 5px;\n}\n\n.btn-info {\n  background: #17a2b8;\n  color: white;\n}\n\n.btn-info:hover {\n  background: #138496;\n}\n\n.btn-danger {\n  background: #dc3545;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #c82333;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
